<template>
    <v-modal :is-open="isOpen"
        class="bg-white"
        @close="$emit('close')">
        <v-modal-header @close="$emit('close')">
            {{ t('filter-title') }}
        </v-modal-header>

        <div class="space-y-md px-10 pb-20">
            <v-info>
                <b>{{ t('filter-info', {results}) }}</b>
            </v-info>

            <v-category-filter-facet v-for="facet in sortedFacets"
                :key="facet.id"
                v-model="selectedFacets[facet.id]"
                :facet="facet" />
        </div>
    </v-modal>
</template>

<script lang="ts" setup>
import type { Facet } from '@apptus/esales-api';
import type { Ref } from 'vue';
import { orderBy } from 'es-toolkit';
import { primaryProductFacets } from '~~/constants/searching';

defineProps<{
    isOpen: boolean
    results?: number
}>();

defineEmits<{
    (event: 'close'): void
}>();

const { t } = useI18n();

const facets = inject<Ref<Facet[]>>('facets', ref([]));
const selectedFacets = inject<Ref<Record<string, (string | number | boolean)[]>>>('activeFilters', ref({}));

const getFacetPriority = (facet: Facet) => {
    // We want the stock availability filter to appear first
    if (facet.id === 'onlyInStock') {
        return 1;
    }
    // These filters are already shown outside the modal, so put them last here
    if (primaryProductFacets.includes(facet.id)) {
        return 3;
    }
    // Let other items retain their original order
    return 2;
};

const sortedFacets = computed(() => {
    if (!facets.value) return [];

    return orderBy(
        facets.value,
        [getFacetPriority],
        ['asc'],
    );
});
</script>

<i18n lang="json">
{
    "et": {
        "filter-title": "Filtrid",
        "filter-info": "Sinu otsingule leiti {results} tulemust"
    },
    "fi": {
        "filter-title": "Suodattimet",
        "filter-info": "Haullesi löytyi {results} tulosta"
    }
}
</i18n>
